import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { filter } from 'rxjs';
import { AppService } from '../app.service';
import { messageService } from '../message.service';
import { qmsService } from '../qms/qms.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { SuccessSnackbarComponent } from '../support/success-snackbar/success-snackbar.component';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-after-login',
  templateUrl: './after-login.component.html',
  styleUrls: ['./after-login.component.scss']
})
export class AfterLoginComponent implements OnInit {

  data1: { applicationUrl: string; };
  loading: boolean;
  orgDetail: any;
  isLoggedIn: any;
  userSettings: any = {
    orgName: null,
    password: null,
    userName: null,
    emailAddress: null,
    //tokenId:32156987,
    overridesession: "N",
    isViewMode: "N",
  }
  dropDownList: any = [];
  data2: { applicationUrl: string; userName: any; };
  dataforsettoken: any = { tokenId: null, overridesession: "N", userId: null };

  constructor(public authService: MsalService, private appService: AppService, private router: Router, public SVC: messageService, public dialog: MatDialog,
    private snackBar: MatSnackBar, private idle: Idle, private keepalive: Keepalive, public qmsservice: qmsService, private message: messageService) {
    this.authService.initialize();
    debugger
  }


  ngOnInit(): void {
    this.dropDownList = [];

    this.isLoggedIn = !!this.authService.instance.getAllAccounts().length;
    this.authService.handleRedirectObservable()
      .pipe(
        filter((response) => response !== null && response.account !== null)
      )
      .subscribe((response) => {
        // Authentication is successful, update login status and user details
        //  this.isLoggedIn = true;
        //  this.getUserDetails(response.account);
        this.userSettings.userName = this.authService.instance.getAllAccounts()[0].username;
      });
    if (this.isLoggedIn) {
      const account = this.authService.instance.getAccountByUsername(
        this.authService.instance.getAllAccounts()[0].username
      );
      this.userSettings.userName = account ? account.username : '';
      this.userOrga();
    }
  }

  isProcessing = true;
  dialogRef: any;

  userData() {
    const userName = this.userSettings.userName.toUpperCase()
    this.appService.userDetailsByName(userName).subscribe((data: any) => {
      this.isProcessing = false;
      if (data.length > 0) {
        localStorage.setItem("userName", data[0].userName + ", " + data[0].userName);
        localStorage.setItem("email", data[0].emailAddress);
        this.message.setUserId(data[0].userId);
        localStorage.setItem("userprofilename", data[0].lastName + " , " + data[0].firstName);
        localStorage.setItem("loggedUserName", userName);
        this.setToke();
      }
      localStorage.setItem("loginMode", "Editable");
      localStorage.setItem("adEnabled", "Y");
      this.visibleDataPopup.close();
    })
  }

  setToke() {
    this.dataforsettoken.tokenId = localStorage.getItem("tokenId")!;
    this.dataforsettoken.orgId = this.message.getOrgId();
    this.dataforsettoken.userId = this.message.getOrgId();

    this.appService.loginUserSetToken(this.dataforsettoken).subscribe((data: any) => {

      debugger;

      if (data.RESULT_TYPE_KEY == 'UW') {


        this.dialogRef = this.dialog.open(ConfirmDialogComponent, {
          // disableClose: false,
          //width: '900px',
          data: {
            message: data.RESULT_KEY,
          }

        });
        this.dialogRef.afterClosed().subscribe((result: { [x: string]: string; }) => {
          if (result['event'] == 'override') {
            this.loading = true;
            this.dataforsettoken.overridesession = "Y";
            this.userSettings.isViewMode = "N";
            debugger;
            this.appService.loginUserSetToken(this.dataforsettoken).subscribe((data: any) => {
              if (data.RESULT_TYPE_KEY == 'E') {
                let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                  duration: 5000,
                  data: {
                    message: data.RESULT_TYPE_KEY == 'S' ? "User logged in sucessfully" : data.RESULT_KEY,
                    type: data.RESULT_TYPE_KEY == 'S' ? 'Success' : 'Error',
                    buttonLabel: "Ok"
                  },
                  horizontalPosition: 'center',
                  verticalPosition: 'top',
                  panelClass: data.RESULT_TYPE_KEY == 'S' ? 'Success' : 'Error',
                });
                sb.onAction().subscribe(() => {
                  sb.dismiss();
                });
              } else if (data.RESULT_TYPE_KEY == "S") {
                localStorage.setItem("tokenId", data.IOP_TOKEN_ID);
                debugger;
                this.router.navigate(['/dashboard']);
              }
              this.loading = false;
            })
          } else if (result['event'] == 'view') {
            this.loading = true;
            this.userSettings.overridesession = "N";
            this.userSettings.isViewMode = "Y";
            this.appService.loginUser(this.userSettings).subscribe((data: any) => {
              if (data.RESULT_TYPE_KEY == 'E') {
                let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                  duration: 5000,
                  data: {
                    message: data.RESULT_TYPE_KEY == 'S' ? "User logged in sucessfully" : data.RESULT_KEY,
                    type: data.RESULT_TYPE_KEY == 'S' ? 'Success' : 'Error',
                    buttonLabel: "Ok"
                  },
                  horizontalPosition: 'center',
                  verticalPosition: 'top',
                  panelClass: data.RESULT_TYPE_KEY == 'S' ? 'Success' : 'Error',
                });
                sb.onAction().subscribe(() => {
                  sb.dismiss();
                });
              } else if (data.RESULT_TYPE_KEY == "S") {

                localStorage.setItem("tokenId", data.IOP_TOKEN_ID);
                debugger
                this.userData();
                this.router.navigate(['/dashboard']);

              }
              this.loading = false;
            })
          }
        });
      } else if (data.RESULT_TYPE_KEY == "S") {
        localStorage.setItem("tokenId", data.IOP_TOKEN_ID);
        this.router.navigate(['/dashboard']);

      }



    })
  }
  userOrga() {
    const userName = this.userSettings.userName.toUpperCase()
    if (location.href == "http://localhost:4200/login/addd") {
      this.data2 = {
        applicationUrl: "https://predev.one-qms.com/login/astad",
        userName: userName
      }
    } else {
      this.data2 = {
        applicationUrl: localStorage.getItem("adapplicationUrl")!,
        userName: userName
      }
    }
    this.appService.userOrgsByName(this.data2).subscribe((data: any) => {
      this.isProcessing = false;
      if (data.length == 1) {
        this.SVC.setOrgId(data[0].orgId);
        localStorage.setItem("userName", data[0].userName + ", " + data[0].userName);
        localStorage.setItem("email", data[0].emailAddress);
        this.message.setUserId(data[0].userId);
        localStorage.setItem("userprofilename", data[0].lastName + " , " + data[0].firstName);
        localStorage.setItem("loggedUserName", userName);

        this.dataforsettoken.tokenId = localStorage.getItem("tokenId")!;
        this.dataforsettoken.orgId = this.message.getOrgId();
        this.dataforsettoken.userId = this.message.getUserId();
        debugger;
        this.appService.loginUserSetToken(this.dataforsettoken).subscribe((data: any) => {
          debugger;
          if (data.RESULT_TYPE_KEY == 'UW') {

            this.dialogRef = this.dialog.open(ConfirmDialogComponent, {
              // disableClose: false,
              //width: '900px',
              data: {
                message: data.RESULT_KEY,
              }

            });
            this.dialogRef.afterClosed().subscribe((result: { [x: string]: string; }) => {
              if (result['event'] == 'override') {
                this.loading = true;
                this.dataforsettoken.overridesession = "Y";
                this.dataforsettoken.isViewMode = "N";
                this.appService.loginUserSetToken(this.dataforsettoken).subscribe((data: any) => {
                  if (data.RESULT_TYPE_KEY == 'E') {
                    let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                      duration: 5000,
                      data: {
                        message: data.RESULT_TYPE_KEY == 'S' ? "User logged in sucessfully" : data.RESULT_KEY,
                        type: data.RESULT_TYPE_KEY == 'S' ? 'Success' : 'Error',
                        buttonLabel: "Ok"
                      },
                      horizontalPosition: 'center',
                      verticalPosition: 'top',
                      panelClass: data.RESULT_TYPE_KEY == 'S' ? 'Success' : 'Error',
                    });
                    sb.onAction().subscribe(() => {
                      sb.dismiss();
                    });
                  } else if (data.RESULT_TYPE_KEY == "S") {
                    localStorage.setItem("tokenId", data.IOP_TOKEN_ID);

                    //  this.userData();
                    this.router.navigate(['/dashboard']);
                    //this.router.navigateByUrl(this.redirectTo);
                  }
                  this.loading = false;
                })
              } else if (result['event'] == 'view') {
                this.loading = true;
                this.userSettings.overridesession = "N";
                this.userSettings.isViewMode = "Y";
                this.appService.loginUser(this.userSettings).subscribe((data: any) => {
                  if (data.RESULT_TYPE_KEY == 'E') {
                    let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                      duration: 5000,
                      data: {
                        message: data.RESULT_TYPE_KEY == 'S' ? "User logged in sucessfully" : data.RESULT_KEY,
                        type: data.RESULT_TYPE_KEY == 'S' ? 'Success' : 'Error',
                        buttonLabel: "Ok"
                      },
                      horizontalPosition: 'center',
                      verticalPosition: 'top',
                      panelClass: data.RESULT_TYPE_KEY == 'S' ? 'Success' : 'Error',
                    });
                    sb.onAction().subscribe(() => {
                      sb.dismiss();
                    });
                  } else if (data.RESULT_TYPE_KEY == "S") {

                    localStorage.setItem("tokenId", data.IOP_TOKEN_ID);
                    this.SVC.setOrgId(data.IP_ORG_ID);
                    this.userData();

                  }
                  this.loading = false;
                })
              }

            });
          } else if (data.RESULT_TYPE_KEY == "S") {
            localStorage.setItem("tokenId", data.IOP_TOKEN_ID);
            this.router.navigate(['/dashboard']);

          }


        })
        localStorage.setItem("loginMode", "Editable");
        localStorage.setItem("adEnabled", "Y");
        debugger;
      } else if (data.length > 1) {
        this.dropDownList = [];
        for (let index = 0; index < data.length; index++) {
          this.dropDownList = this.dropDownList.concat({
            valueExp: data[index].orgId,
            displayExp: data[index].orgName
          });
        }
        this.SVC.setOrgId("");
        this.visibleDataPopup = this.dialog.open(this.dataPopup, this.dataPopupConfig);

      }



      //this.loading=false;
    })
  }

  visibleDataPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('dataPopup', { static: true }) dataPopup: TemplateRef<any>;

  dataPopupConfig = {
    width: '700px',
    height: '270px',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
  };



  selectedValue: any = [];


  onDropdownSelect(item: any) {

  }

  onDropdownRemoved(item: any) {

  }

  logoutFunction() {
    if (this.message.getOrgId()) {
      this.userData()
    } else {
      alert("Please select Organization")
    }


  }

  logutCancel() {
    this.authService.instance.clearCache();

    this.authService.logout().subscribe(
      (response) => {
        // Handle logout success
      },
      (error) => {
        console.error('Logout error:', error);
      }
    );
  }


}
